<div class="flex flex-col">
  <h2 class="text-4xl font-bold text-center">
    {{data.title}}
  </h2>
  @if (data.message) {
    <div class="text-center"></div>
  }

  <div class="flex justify-center gap-4 mt-4">
    <button emsysButton (click)="close()">Cancel</button>
    <button emsysButton appearance="primary" (click)="close(true)">Ok</button>
  </div>
</div>
